<template>
  <div id="app">
    <HeaderHome v-show="videoShow"></HeaderHome>
    <iframe
      src="mms3D/index1.html"
      frameborder="0"
      id="iframe"
      class="iframe"
    ></iframe>
    <router-view v-if="videoShow"></router-view>
    <video
      class="yunVideo"
      id="video"
      autoplay
      muted
      src="../src/assets/video/yun.mp4"
      v-if="flag"
      v-show="showttt"
    ></video>
  </div>
</template>

<script>
import HeaderHome from "../src/components/headerHome";
export default {
  name: "App",
  data() {
    return {
      flag: true,
      showttt: false,
      videoShow: false,
    };
  },
  mounted() {
    window.loadDone = this.loadDone;
    this.videoYun();
  },
  methods: {
    loadDone(value) {
      this.showttt = true;
      this.videoShow = value;
    },
    videoYun() {
      var _this = this;
      var elevideo = document.getElementById("video");
      elevideo.addEventListener(
        "ended",
        function () {
          _this.flag = false;
        },
        false
      );
    },
  },
  components: {
    HeaderHome,
  },
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: relative;
  width: 100vw;
  overflow: hidden;
  height: 100%;
  color: #fbfcfc;
  position: relative;
}

/* @font-face {
  font-family: SOURCEHANSANSCN-REGULAR;
  src: url("./assets/font/SOURCEHANSANSCN-REGULAR.OTF");
}
@font-face {
  font-family: pangmenzhengdao;
  src: url("./assets/font/庞门正道标题体2.0增强版.TTF");
} */

html,
body {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
}

ul {
  margin: 0;
  padding: 0;
}

li {
  list-style: none;
}

i {
  font-style: normal;
}

.iframe {
  width: 100vw;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 6;
}
.yunVideo {
  width: 100%;
  height: 100%;
  z-index: 15;
  position: absolute;
  object-fit: fill;
  top: 0;
  left: 0;
}
</style>
